import { Tab } from "@headlessui/react";
import { PencilAltIcon } from "@heroicons/react/outline";
import React, { FC, Fragment,useState,useEffect,useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Route, Redirect,useHistory,Link,useParams,useLocation} from 'react-router-dom';
import visaPng from "images/vis.png";
import mastercardPng from "images/mastercard.svg";
import Input from "shared/Input/Input";
import Label from "components/Label/Label";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcImage from "shared/NcImage/NcImage";
import StartRating from "components/StartRating/StartRating";
import NcModal from "shared/NcModal/NcModal";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import CheckoutForm from "./CheckoutForm";
import { DateRage } from "components/HeroSearchForm/StaySearchForm";
import axios from 'axios';  
import GuestsInput from "components/HeroSearchForm/GuestsInput";
import { Helmet } from "react-helmet";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl, isValidPhoneNumber } from 'react-phone-number-input'
// import ReactGA from "react-ga4";
// ReactGA.initialize("your GA measurement id");



export interface CheckOutPageProps {
  className?: string;
  clientSecret?: string;
  DefaultUserID?: string;
  autoFocus?: boolean;
  referralCandy?:JSON;
}

const CheckOutPage: FC<CheckOutPageProps> = ({ 
  className = "",
  DefaultUserID = localStorage.getItem("user_id") ? localStorage.getItem("user_id") :"",
  autoFocus = false,
  referralCandy = localStorage.getItem("referralCandy") ? localStorage.getItem("referralCandy") :"",
}) => {
  const appearance = {
    theme: 'stripe',
  };
const [clientSecret, setClientSecret] = useState("");
const [selectedDate, setSelectedDate] = useState<DateRage>({
  /*startDate: moment(),
  endDate: moment().add(1, "days"),*/
  startDate: null,
  endDate: null,
});
let search                                                  = window.location.search;
const history                                               = useHistory();
const [guestyListingId, setguestyListingId]                 = useState(new URLSearchParams(search).get('listing'));
const [checkin, setCheckin]                                 = useState(new URLSearchParams(search).get('checkin'))
const [checkout, setCheckout]                               = useState(new URLSearchParams(search).get('checkout'))
const [adults, setAdults]                                   = useState(new URLSearchParams(search).get('adult')?new URLSearchParams(search).get('adult'):0);
const [children, setChildren]                               = useState(new URLSearchParams(search).get('children')?new URLSearchParams(search).get('children'):0);
const [infants, setInfants]                                 = useState(new URLSearchParams(search).get('infants'));
const [isInvalidBooking, setIsInvalidBooking]               = useState(false);
const [isdataLoaded, setIsdataLoaded]                       = useState(false);
const [priceBreakDown, setPriceBreakDown]                   = useState("");
const [listingName, setListingName]                         = useState("");
const [reviewCount, setReviewCount]                         = useState(0);
const [reviewRating, setReviewRating]                       = useState(0);
const [listingImg, setListingImg]                           = useState("");
const [beds, setBeds]                                       = useState(0);
const [bathrooms, setBathrooms]                             = useState(0);
const [totalGuest,setTotalGuest]                            = useState(0);
const [totalPaymentPrice,setTotalPaymentPrice]              = useState(0);
const [serviceFee,setServiceFee]                            = useState(0);
const [taxAmount,setTaxAmount]                              = useState(0);
const [currency_code,setCurrency_code]                      = useState("");
const [show, setShow]                                       = useState(false);
const [success, setSuccess]                                 = useState(false);
const [errorMessage, setErrorMessage]                       = useState('');
const [orderId, setOrderId]                                 = useState(false);
const [authenticated, setauthenticated]                     = useState(null);
const [user_id,setUserId]                                   = useState(DefaultUserID);
const [bookingRef,setBookingRef]                            = useState(""); 
const [paypalClientid,setPaypalClientid]                    = useState(""); 
const [stripeClientid,setStripeClientid]                    = useState(""); 
const [paypalCurrency,setPaypalCurrency]                    = useState(""); 
const [paypalTotalPrice,setPaypalTotalPrice]                = useState(0); 
const [isOpenModalCoupon, setIsOpenModalCoupon]             = useState(false);
const [errorMsg, setErrorMsg]                               = useState('');
const [successMsg,setSuccessMsg]                            = useState('');
const [detailsCoupon,setDetailsCoupon]                      = useState({coupon_code:""});
const CouponRef                                             = useRef<HTMLInputElement>(null);
const [showPopover, setShowPopover]                         = useState(autoFocus);
const [isDicountApplied, setIsDicountApplied]               = useState(false);
const [isGiftCard, setIsGiftCard]                           = useState(false);
const [isMerchantsAllow, setIsMerchantsAllow]               = useState(true);
const [isCartProceed, setisCartProceed]                     = useState(false);
const [appliedCode, setAppliedCode]                         = useState(new URLSearchParams(search).get('coupon_code'));
const [processing, setProcessing]                           = useState(false);
const [disabled, setDisabled]                               = useState(false);
const [guestDetailsRequired, setGuestDetailsRequired]       = useState(false);
const [details,setDetails]                                  = useState({email:"",phone:""});
let searchParams                                            = new URLSearchParams(search);
const emailRef                                              = useRef<HTMLInputElement>(null);
const phoneRef                                              = useRef<HTMLInputElement>(null);
const [emailMandatory, setEmailMandatory]                   = useState(false);
const [phoneMandatory, setPhoneMandatory]                   = useState(false);
const [value, setValue]                                     = useState("");
const [cartDetails, setCartDetails]                         = useState([]);
const [grandTotalAmtDisplay, setgrandTotalAmtDisplay]       = useState(0);
const [grandTotalAmt, setGrandTotalAmt]                     = useState(0);
const [cartIDS, setCartIDS]                                 = useState([]);
const [grandTotalBD, setGrandTotalBD]                       = useState("");
const [bookingSource, setBookingSource]                     = useState("");
const [addmorelink, setAddmorelink]                         = useState("");
const [reFerralCandy,setReFerralCandy]                      = useState(referralCandy);
//console.log("ReferralCandy="+reFerralCandy);

const DeleteCart = (id:any)=>{
    console.log(id);
    axios.post(process.env.REACT_APP_BASE_URL+'DeleteCart',{
      user_id:DefaultUserID,
      cart_id:id
    }
    ).then(res => {
      if(res.data.status==401){
        //setCalendarMessage(res.data.response);
      }
      if(res.data.status==200){
        history.push("/checkout");
        history.go(0);
      }
    });
}

const randomString = (length:any) =>{
  var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var result = '';
  for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
  return result;
}
let stripePromise: any;
useEffect(() => {
  setUserId(localStorage.getItem("user_id"));
  if(DefaultUserID==""){
    history.push("404");
  }
}, [DefaultUserID]);

useEffect(() => {
  if(cartIDS.length > 0){
    axios.get(process.env.REACT_APP_BASE_URL+'check_validate_guest_details?user_id='+DefaultUserID)
.then(res => {
        console.log(res.data.status);
        if(res.data.status==true){
          setGuestDetailsRequired(res.data.response_data.response_code);
          if(res.data.response_data.response_type=='1'){
            setEmailMandatory(true);
          }
          if(res.data.response_data.response_type=='2'){
            setPhoneMandatory(true);
          }
          if(res.data.response_data.response_type=='3'){
            setEmailMandatory(true);
            setPhoneMandatory(true);
          }
        }else{
          setGuestDetailsRequired(res.data.response_data.response_code);
        }
    })
  }
}, [cartIDS,appliedCode,isMerchantsAllow]);

const options = {
  clientSecret};
useEffect(() => {
  axios.get(process.env.REACT_APP_BASE_URL+'getCartDetails?user_id='+DefaultUserID+"&discountcode="+(appliedCode!=null?appliedCode:''))
.then(res => {
  setIsdataLoaded(true);
  if(res.data.success==true){
    setCartDetails(res.data.cart_details);
    setIsInvalidBooking(true);
    setPaypalClientid(res.data.merchant_info.paypal_client_id);
    setStripeClientid(res.data.merchant_info.stripe_client_id);
    setGrandTotalAmt(res.data.price_details.payment_price.grandTotal);
    setgrandTotalAmtDisplay(res.data.price_details.display_price.grandTotal);
    setPaypalCurrency(res.data.currency_code);
    setPaypalTotalPrice(res.data.price_details.payment_price.grandTotal);
    setCartIDS(res.data.cart_ids);
    setGrandTotalBD(res.data.price_details.display_price.display_price_html);
    setIsDicountApplied(res.data.is_discount_applied);
    setIsMerchantsAllow(res.data.isMerchantsAllow);
    setisCartProceed(res.data.isCartProceed);
    setBookingSource(res.data.bookingSource);
    setAddmorelink(res.data.addmorelink);
    //setPaypalCurrency(res.data.booking_price_details.paypal_price.currency_code);
    //setPaypalTotalPrice(res.data.booking_price_details.paypal_price.total_price);
  }
});
  
}, [appliedCode,bookingSource]);
if(stripeClientid!=''){
   stripePromise = loadStripe(stripeClientid);
}
useEffect(() => {
  // Create PaymentIntent as soon as the page loads
  if(paypalTotalPrice > 0 && bookingSource!=''){
    var BookingRerence_Number = randomString(10);
    axios.post(process.env.REACT_APP_BASE_URL+"stripe_signature_v1", {
      items: [{amount: paypalTotalPrice,
                cart_ids:cartIDS,
                bookingRefNo:BookingRerence_Number,
                user_id:user_id,
                bookingSource:bookingSource,
                discount_code:(appliedCode!=null?appliedCode:''),
                reFerralCandy:reFerralCandy
              }]
    })
  .then(function (response) {
    setClientSecret(response.data.clientSecret);
    setBookingRef(BookingRerence_Number)
  });
}
}, [cartIDS,appliedCode,bookingSource]);
  // FOR PAYPAY 
const createOrder = (data:any, actions:any) => {
  return actions.order.create({
    purchase_units: [
      {
        reference_id: guestyListingId,
        description: 'Booking Payment For '+listingName,
        amount: {
          currency_code: paypalCurrency,
          value:paypalTotalPrice
        },
      },  
    ],
    application_context: {
      shipping_preference:'NO_SHIPPING'
    }
  })
    .then((orderID:any) => {
      setOrderId(orderID);
      return orderID
  })
}
const onApprove = (data:any,actions:any) => {
  return actions.order.capture().then(function (details:any) {
    const { payer } = details
    //console.log(details);
    //console.log(actions);
    setSuccess(true);
    var BookingRerence_Number = randomString(10);
    axios.post(process.env.REACT_APP_BASE_URL+"paypal_booking_v1", {
      items: [{amount: paypalTotalPrice,
        cart_ids:cartIDS,
        bookingRefNo:BookingRerence_Number,
        user_id:user_id,
        bookingSource:bookingSource,
        payment_details:details,
        discount_code:(appliedCode!=null?appliedCode:''),
        reFerralCandy:reFerralCandy
          }
        ]
    })
  .then(function (response) {
    if(response.data.success){
      history.push("pay-done/"+response.data.booking_ref_no);
    }
  });
  })
}
const onError = (data?:any, actions?:any) => {
  setErrorMessage("An error occured with your payment")
};
function closeModalCoupon() {
  setIsOpenModalCoupon(false);
}
function openModalCoupon() {
  setIsOpenModalCoupon(true);
};
const validateCouponInput = () => {
  const fields = [
    {
      name: 'name',
      value: detailsCoupon.coupon_code,
      message: 'Code should not be blank.'
    }
  ];
  const isNotFilled = fields.some(field => {
    if (field.value.trim() === '') {
      setErrorMsg(field.message);
      //field.name === 'email' ? emailRef.current.focus() : passwordRef.current.focus();
      return true;
    }
    setErrorMsg('');
    return false;
  });
  return isNotFilled;
};
const submitHandlerCoupon = (event: React.FormEvent<HTMLFormElement>) =>{
  event.preventDefault();
  const isInvalid = validateCouponInput();
  if (!isInvalid) {
    axios.post(process.env.REACT_APP_BASE_URL+'getCoupon_v1', {
      detailsCoupon,
      user_id:DefaultUserID,
      cart_id:cartIDS
    })
  .then(function (response) {
    console.log(response.data);
    if(response.data.status==200){
      setDetailsCoupon({coupon_code:""});
      setSuccessMsg(response.data.response);
      setAppliedCode(response.data.coupon);
      setIsDicountApplied(true);
      if(searchParams.has('coupon_code')) {
        searchParams.delete('coupon_code')
        history.replace({
          search: searchParams.toString(),
        })
      }
      if(!searchParams.has('coupon_code')) {

        searchParams.append('coupon_code',response.data.coupon);
        console.log(searchParams.toString());
        history.push({
          pathname: "/checkout",
          search: searchParams.toString(),
        });
      }
      setIsGiftCard(response.data.is_gift_card);
      setIsOpenModalCoupon(false);
      //history.go(0);
    }else{
      setErrorMsg(response.data.response);
    }
  })
  .catch(function (error) {
    console.log(error);
  });
  } else {
    setSuccessMsg('');
  }
};
const renderMotalCoupon = () => {
  return (
    <Transition appear show={isOpenModalCoupon} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto model-sm-min"
        onClose={closeModalCoupon}
      >
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block py-8 h-screen  w-full sm:w-xl Coupons-model">
              <div className="inline-flex flex-col w-1/2 max-w-xl text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-1/2">
                <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                  <h3
                    className="text-lg font-medium leading-6 text-gray-900"
                    id="headlessui-dialog-title-70"
                  >
                    Coupon
                  </h3>
                  <span className="absolute left-3 top-3">
                    <ButtonClose onClick={closeModalCoupon} />
                  </span>
                </div>
                <div className="px-8 text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200">
                <div className="container mt-5">
                  <div className="max-w-md mx-auto space-y-6">
                    {/* <div className="grid gap-3">
                    </div> */}
                    {successMsg && 
                    <div className="alert alert-success" role="success alert"><span className="las la-check-circle"></span>
                    {successMsg}
                    </div>}
                    {errorMsg && 
                    <div className="alert alert-warning" role="warning alert"><span className="las la-exclamation-circle"></span>
                    {errorMsg}</div>}
                    {/* FORM */}
                    <form className="grid grid-cols-1 gap-6" onSubmit={submitHandlerCoupon}>
                    <label className="block">
                        {/* <span className="text-neutral-800 dark:text-neutral-200">
                          Name
                        </span> */}
                        <Input
                          type="text"
                          placeholder="Enter a coupon code"
                          className="mt-1"
                          name="coupon_code"
                          id="coupon_code"
                          onChange={event=>setDetailsCoupon({...detailsCoupon,coupon_code:event.target.value})}
                          ref={CouponRef}
                          autoComplete="off"
                          autoFocus={showPopover}
                          value={detailsCoupon.coupon_code}
                        />
                      </label>
                      <ButtonPrimary type="submit">Apply</ButtonPrimary>
                    </form>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};
console.log(guestDetailsRequired);
const renderSidebarCartDetails = () => {
  return (
    <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 
    space-y-6 sm:space-y-4 px-0 sm:p-3 xl:p-2 ">
      
      <div className="p-2">
      {cartDetails && cartDetails.length!=0 ? 
        <div>
        {cartDetails.map((cartItems:any) => (
          <div className={`p-2 ${cartItems.remove_cart_class}`}>
          <div className="flex flex-col sm:flex-row justify-between">
          <div className="flex">
          <div className="flex-shrink-0 w-full sm:w-40">
            <div className=" w-checkout-page-sm-img  overflow-hidden mb-2">
              <NcImage src={cartItems.listing_image} />
              <button onClick={(e) => DeleteCart(cartItems.id)}  className="btn--delete-cart  rounded-full focus:outline-none text-neutral-6000 dark:text-neutral-400">Remove</button>
            </div>
          </div>
          <div className="py-0  px-3 space-y-0">
            <div>
            {/* <span className="text-base font-medium mt-0 block">
                Tiny House
              </span> */}
              <span className="text-sm text-neutral-500 dark:text-neutral-400 line-clamp-1 font-bold">
              {cartItems.listing_name}
              </span>
              {/* <span className="text-base font-medium mt-1 block">
                The Lounge & Bar
              </span> */}
            </div>
            <div className="mb-0">
            <span className="block  text-sm text-neutral-500 dark:text-neutral-400 mb-0">
              {cartItems.beds} beds · {cartItems.bathrooms} baths
            </span>
            </div>
  
            <div className="mb-0">
            <span className="block  text-sm text-neutral-500 dark:text-neutral-400 mb-0">
            Check In - {cartItems.check_in_date} 
            </span>
            </div>
            <div className="mb-0">
            <span className="block  text-sm text-neutral-500 dark:text-neutral-400 mb-0"> 
            Check Out - {cartItems.check_out_date} 
            </span>
            </div>
            <div className="mb-0">
            <span className="block  text-sm text-neutral-500 dark:text-neutral-400 mb-0">
            Guests - {cartItems.totalGuest} Guests
            </span>
            </div>
            {/* <StartRating point={cartItems.reviewStar}  reviewCount={cartItems.reviewCount} isHost={false}  /> */}
          </div>
          </div>
          <div>
          <div className="show-hide-payment-form-payment">
            <div dangerouslySetInnerHTML={ {__html: cartItems.line_price.line_price_html} } />
          </div>
          </div>
        </div>
        <div className="text-center">{cartItems.message}</div>
        <div className="border-b border-neutral-200 dark:border-neutral-700 p-0"></div>
        </div>
        ))}
        <div className="flex flex-col space-y-4 payment-detail-part">
          <div className="border-b border-neutral-200 dark:border-neutral-700 p-0"></div>
            <div className="flex justify-between total-main">
              <div className="width-70-box"><a href={addmorelink}>Add More</a></div>
                <div className="width-40-box">
                <div dangerouslySetInnerHTML={ {__html: grandTotalBD} } />
              </div>
            </div>       
          </div> 
        </div>
        :
        <div className="show-bfr-error">
          <span>
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"  aria-hidden="true" role="presentation" focusable="false"><circle cx="16" cy="16" r="14" fill="none"></circle><path d="m16 8v10" fill="none"></path><circle cx="16" cy="22.5" fill="#000" r=".5"></circle></svg>
            <p>It looks like someone else has just requested a reservation for the same dates. If you’re set on this place, change your trip dates and try again.</p>
          </span>
        </div>
      }
      </div>
    </div>
  );
};
const removeDiscount = () => {
  if(searchParams.has('coupon_code')) {
    searchParams.delete('coupon_code')
    history.replace({
      search: searchParams.toString(),
    })
  }
  setIsDicountApplied(false);
  history.go(0);
}
const renderXClear = () => {
  return (
    <span onClick={() => removeDiscount()} className="w-4 h-4 rounded-full bg-primary-500 text-white flex items-center justify-center ml-3 cursor-pointer">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-3 w-3"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
          clipRule="evenodd"
        />
      </svg>
    </span>
  );
};
const renderGiftCardsIcon = () => {
    return (
      <span className="theme-color-bg"> <i className="la la-gift" aria-hidden="true"></i></span>
    );
};
const renderCouponIcon = () => {
  return (
    <span className="theme-color-bg">  <svg className="mr-2 w-5" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 122.88">
        <path d="M13.7,49.54,8,33.63a3.47,3.47,0,0,1,2.1-4.44,3.93,3.93,0,0,1,.81-.18L27.3,27.3,29,10.79a3.47,3.47,0,0,1,3.81-3.1,2.9,2.9,0,0,1,.71.15l16,4.11L58.8,1.21A3.49,3.49,0,0,1,63.7.83a3.91,3.91,0,0,1,.61.68l9,12.17,15.91-5.8A3.48,3.48,0,0,1,93.69,10a3.44,3.44,0,0,1,.19.83l1.7,16.51L112.09,29a3.47,3.47,0,0,1,2.71,5.09l-7.3,13.77,14,10.83a3.46,3.46,0,0,1,.62,4.87,3.18,3.18,0,0,1-.72.7L109.2,73.33,115,89.24a3.48,3.48,0,0,1-2.08,4.45,3.44,3.44,0,0,1-.83.19l-16.51,1.7L93.88,112a3.48,3.48,0,0,1-3.81,3.1,3.61,3.61,0,0,1-1.27-.38L75,107.49l-10.85,14a3.46,3.46,0,0,1-5.57-.1l-9.08-12.25-15.91,5.74A3.47,3.47,0,0,1,29,112.05L27.3,97.29,10.53,93.82a3.46,3.46,0,0,1-2.7-4.09A2.62,2.62,0,0,1,8,89.11L13.7,73.34,1.4,64.23a3.48,3.48,0,0,1-.72-4.86,3.42,3.42,0,0,1,.77-.75L13.7,49.54Zm62.39-6.2L55.66,78.86a6.86,6.86,0,0,1-.67,1,2.76,2.76,0,0,1-.82.71,3.14,3.14,0,0,1-1.1.31,10.25,10.25,0,0,1-1.31.07H47.9a1.16,1.16,0,0,1-1.16-1.15,1.18,1.18,0,0,1,.21-.67L67.39,43.57a7.2,7.2,0,0,1,.65-1l0-.06a2.84,2.84,0,0,1,.78-.65A3.15,3.15,0,0,1,70,41.59h0a10,10,0,0,1,1.29-.07h3.85a1.16,1.16,0,0,1,1.16,1.15,1.18,1.18,0,0,1-.21.67Zm-7.4,36.07c-1.72-1.8-2.59-4.56-2.59-8.28s.87-6.48,2.59-8.28,4.52-2.7,8.4-2.7,6.68.9,8.4,2.7,2.58,4.56,2.58,8.28-.86,6.48-2.58,8.28-4.52,2.7-8.4,2.7-6.68-.9-8.4-2.7Zm6-11.44v8h1.3a16.21,16.21,0,0,0,3.27-.26c.22-.18.33-.67.33-1.46v-8h-3a3,3,0,0,0-1.58.26c-.21.18-.32.67-.32,1.46ZM37.39,60q-2.58-2.7-2.58-8.28t2.58-8.28q2.58-2.7,8.4-2.7t8.4,2.7q2.58,2.7,2.58,8.28T54.19,60q-2.58,2.7-8.4,2.7T37.39,60Zm6-11.44v8h3a2.93,2.93,0,0,0,1.57-.27c.22-.18.33-.67.33-1.46v-8H46.93a15.28,15.28,0,0,0-3.26.27c-.22.17-.33.66-.33,1.45ZM16,35.46l5,14a3.48,3.48,0,0,1-1.14,4.13L9.3,61.44,19.9,69.3a3.48,3.48,0,0,1,1.2,4L15.84,87.84,31,91a3.48,3.48,0,0,1,3,3.05l1.49,12.9,14.05-5.06A3.47,3.47,0,0,1,53.59,103l7.91,10.68,9.74-12.61A3.48,3.48,0,0,1,75.69,100l11.81,6.21L89,92.1A3.47,3.47,0,0,1,92.06,89L107,87.43,101.8,73.32a3.46,3.46,0,0,1,1.18-4l10.67-7.92-12.52-9.67A3.5,3.5,0,0,1,100,47.18l6.26-11.8L92.1,33.93A3.48,3.48,0,0,1,89,30.82L87.43,15.93,73.32,21.08a3.48,3.48,0,0,1-4-1.18L61.24,9l-7.8,9.07a3.48,3.48,0,0,1-3.5,1.1L35.5,15.5,33.92,30.78a3.47,3.47,0,0,1-3.1,3.14L16,35.46Z"/>
        </svg>
      </span>
  );
}
const directbooking = () => {
  var BookingRerence_Number = randomString(10);
  setProcessing(true);
  setDisabled(true);
    axios.post(process.env.REACT_APP_BASE_URL+"direct_booking_v1", {
      items: [{amount: paypalTotalPrice,
        cart_ids:cartIDS,
        bookingRefNo:BookingRerence_Number,
        user_id:user_id,
        bookingSource:bookingSource,
        discount_code:(appliedCode!=null?appliedCode:''),
        reFerralCandy:reFerralCandy
      }]
    })
  .then(function (response) {
    //console.log(response.data.success);
    if(response.data.success){
      history.push("pay-done/"+response.data.booking_ref_no);
    }
  });
}
const submitHandler = (event: React.FormEvent<HTMLFormElement>) =>{
  event.preventDefault();
  if(emailMandatory && phoneMandatory){
    const isInvalid             = validateInput();
    const isPhoneInvalid        = isValidPhoneNumber(value);
    if (isInvalid==true && isPhoneInvalid==true) {
        setSuccessMsg("You're good to go!");
        details.phone           = value;
        axios.post(process.env.REACT_APP_BASE_URL+'update_guest_details?user_id='+DefaultUserID, details)
      .then(function (response) {
        if(response.data.status==200){
          //setsuccess('Successfully register');
          setDetails({email:"",phone:""});
          setEmailMandatory(false);
          setPhoneMandatory(false);
          window.location.reload();
        }else{
          //setError(response.data.response);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    } else {
      if(!isPhoneInvalid){
        setSuccessMsg("");
        setErrorMsg('Please input correct phone number');
      }
      
    }
  }else if(emailMandatory){
    const isInvalid       = validateInput();
    if (isInvalid) {
      setSuccessMsg("You're good to go!");
      details.phone           = value;
      axios.post(process.env.REACT_APP_BASE_URL+'update_guest_details?user_id='+DefaultUserID, details)
    .then(function (response) {
      if(response.data.status==200){
        //setsuccess('Successfully register');
        setDetails({email:"",phone:""});
        setEmailMandatory(false);
        setPhoneMandatory(false);
        window.location.reload();
      }else{
        //setError(response.data.response);
      }
    })
    .catch(function (error) {
      console.log(error);
    });
    } else {
      setSuccessMsg('');
    }
  }else if(phoneMandatory){
    const isPhoneInvalid       = isValidPhoneNumber(value);
    if (isPhoneInvalid) {
      setSuccessMsg("You're good to go!");
      details.phone           = value;
      axios.post(process.env.REACT_APP_BASE_URL+'update_guest_details?user_id='+DefaultUserID, details)
    .then(function (response) {
      console.log(response.data.response);
      if(response.data.status==200){
        //setsuccess('Successfully register');
        setDetails({email:"",phone:""});
        setEmailMandatory(false);
        setPhoneMandatory(false);
        window.location.reload();
      }else{
        //setError(response.data.response);
      }
    })
    .catch(function (error) {
      console.log(error);
    });
    } else {
      setSuccessMsg("");
      setErrorMsg('Please input correct phone number');
    }
  }
}
const validateInput = () => {
  const fields = [
    {
      name: 'email',
      value: details.email,
      message: 'Email should not be blank.'
    }
  ];
  const isNotFilled = fields.some(field => {
    if (field.value.trim() === '') {
      setErrorMsg(field.message);
      //field.name === 'email' ? emailRef.current.focus() : passwordRef.current.focus();
      return false;
    }
    setErrorMsg('');
    return true;
  });
  return isNotFilled;
};
const renderPaymentSection = () => {
  return (
    <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8 padding-box-20">
      <h2 className="text-2xl sm:text-2xl lg:text-2xl font-semibold font-sm-mid-20">Confirm and payment</h2>
      <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
      {!isCartProceed &&           
        <div className="alert alert-danger" role="alert">  <span className="las la-exclamation-circle"></span>These dates are no longer available.</div>
      }
      {isCartProceed && !guestDetailsRequired ?
          <div className="pay-with-main">
            <div className="w-full coupon-page">
              <h3 className="font-size-16 font-semibold">Pay with</h3>
              {isDicountApplied ?
                <div className="relative color-theme-icon">
                  <button className="flex items-center justify-center px-4 py-2 text-sm rounded-full border border-neutral-300 dark:border-neutral-700 focus:outline-none " id="headlessui-popover-button-:r1b:"
                  aria-expanded="false">
                  {isGiftCard ? renderGiftCardsIcon() :renderCouponIcon()}
                  <span>{appliedCode}</span>
                  {renderXClear()}
                  </button>
                </div>
                :
                <a href={void(0)} onClick={openModalCoupon}> Enter a coupon</a>
              }
            </div>
            {isMerchantsAllow ? 
              <div className="mt-4 button-check-out-page">
                <Tab.Group>
                  <Tab.List className="flex">
                  <Tab as={Fragment}>
                      {({ selected }) => (
                        <button
                          className={`px-4 py-1.5 sm:px-6 sm:py-2.5  rounded-full flex items-center justify-center focus:outline-none  ${
                            selected
                              ? "bg-neutral-800 text-white"
                              : " text-neutral-6000 dark:text-neutral-400"
                          }`}
                        >
                          <span className="mr-2.5">Credit card</span>
                          <img className="w-8" src={visaPng} alt="" />
                          <img className="w-8" src={mastercardPng} alt="" />
                        </button>
                      )}
                    </Tab>
                    <Tab as={Fragment}>
                      {({ selected }) => (
                        <button
                          className={`px-4 py-1.5 sm:px-6 sm:py-2.5 rounded-full focus:outline-none ${
                            selected
                              ? "bg-neutral-800 text-white"
                              : "text-neutral-6000 dark:text-neutral-400"
                          }`}
                        >
                          Paypal
                        </button>
                      )}
                    </Tab>
                  </Tab.List>
                  <div className="w-full border-b border-neutral-200 my-5 mb-3"></div>
                  <Tab.Panels>
                    <Tab.Panel className="space-y-5">
                    {clientSecret && stripePromise && (
                      <Elements options={options} stripe={stripePromise}>
                        <CheckoutForm clientSecret={clientSecret} bookingRef={bookingRef} />
                      </Elements>
                    )}
                    </Tab.Panel>
                    <Tab.Panel className="space-y-5">
                      <PayPalScriptProvider 
                          options={{
                            "client-id":paypalClientid,
                            currency: paypalCurrency,
                            intent: "capture",
                          }}
                      >
                      <div className="pt-4  w-1.5 ">
                        {/* <ButtonPrimary type="submit">Confirm and pay</ButtonPrimary>
                        */}
                        <PayPalButtons 
                          style={{color:"silver",
                                  layout:"horizontal",
                                  height:48,
                                  tagline:false,
                                  shape:"pill"}}
                              createOrder={createOrder}
                              onApprove={onApprove} 
                              onError={onError}
                        />
                        {/* asdasd */}
                        </div>
                      </PayPalScriptProvider>
                    </Tab.Panel>
                  </Tab.Panels>
                </Tab.Group>
              </div>
              :
              <div className="mt-6 button-check-out-page">
                  <ButtonPrimary disabled={processing || disabled} onClick={directbooking} type="button">
                  <span id="button-text">
                    {processing ? (
                      <div className="spinner" id="spinner"></div>
                    ) : (
                      "Book now"
                    )}
                  </span>
                </ButtonPrimary>
              </div>
            }
            {renderMotalCoupon()}
          </div>
        :
        <div>
          {successMsg && 
          <div className="alert alert-success" role="success alert"><span className="las la-check-circle"></span>
          {successMsg}
          </div>}
          {errorMsg && 
          <div className="alert alert-warning" role="warning alert"><span className="las la-exclamation-circle"></span>
          {errorMsg}</div>}
          <form className="grid grid-cols-1 gap-6" onSubmit={emailMandatory && phoneMandatory ? submitHandler:submitHandler}>
          {emailMandatory ?
          <label className="block">
          <span className="text-neutral-800 dark:text-neutral-200">
            Email address
          </span>
          <Input
            type="email"
            placeholder=""
            className="mt-1"
            name="email"
            id="email"
            onChange={event=>setDetails({...details,email:event.target.value})}
            ref={emailRef}
            autoComplete="off"
            autoFocus={showPopover}
            value={details.email}
          />
        </label>
        :''}
          {phoneMandatory ? 
            <label className="block">
            <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
              Phone
            </span>
            <PhoneInput
              placeholder="Enter phone number"
              international
              value={details.phone}
              defaultCountry="SG"
              countryCallingCodeEditable={false}
              onChange={setValue}
              phoneDigits={8}
              error={value ? (isValidPhoneNumber(value) ? undefined : 'Invalid phone number') : 'Phone number required'}
            />
            Please enter your phone number first, as required by our booking system.
          </label>
          
          :''
          }
          {phoneMandatory || emailMandatory ? 
          <ButtonPrimary type="submit">Continue</ButtonPrimary>
          :""
          }
          </form>
        </div>
        }
    </div>
  );
};
const renderskeletonLoader = () => {
  return (
    <div>
      <div className="custom-loader lg:flex-row gap-3 flex">
          <div className="w-70-loader  lg:w-3/5 xl:w-2/3 border-neutral-200  sm:rounded-2xl sm:border">
            <div className="card m-2">
                <div className="card-body">
                  <div className="row mb-5">
                      <div className="col-12">
                        <div className="p-3 bg-grey skeleton"></div>
                      </div>
                  </div>
                  <div className="row mb-3">
                      <div className="col-3">
                        <div className="p-2 bg-grey skeleton"></div>
                      </div>
                  </div>
                  <div className="row mb-4">
                      <div className="col-6">
                        <div className="p-2 bg-grey mb-2 skeleton"></div>
                        <div className="p-2 bg-grey mb-2 skeleton"></div>
                      </div>
                      <div className="col-6">
                        <div className="p-2 bg-grey mb-2 skeleton"></div>
                        <div className="p-2 bg-grey mb-2 skeleton"></div>
                      </div>
                  </div>
                  <div className="row">
                      <div className="col-3">
                        <div className="p-2 bg-grey mb-3 skeleton"></div>
                      </div>
                  </div>
                  <div className="row mb-5">
                      <div className="col-4">
                        <div className="p-2 bg-grey mb-2 skeleton"></div>
                      </div>
                      <div className="col-2">
                        <div className="p-2 bg-grey mb-2 skeleton"></div>
                      </div>
                  </div>
                  <div className="row mb-4 justify-content-between">
                      <div className="col-3">
                        <div className="p-2 bg-grey mb-2 skeleton"></div>
                      </div>
                      <div className="col-3">
                        <div className="p-2 bg-grey mb-2 skeleton"></div>
                      </div>
                  </div>
                  <div className="row">
                      <div className="col-3">
                        <div className="p-2 bg-grey mb-3 skeleton"></div>
                      </div>
                  </div>
                </div>
            </div>
          </div>
          <div className="w-30-loader hidden lg:block flex-grow border-neutral-200 sm:rounded-2xl sm:border">
            <div className="card m-2">
                <div className="card-body">
                  <div className="row mb-4">
                      <div className="col-5">
                        <div className="p-5 bg-grey skeleton"></div>
                        <div className="p-2 bg-grey skeleton"></div>
                      </div>
                      <div className="col-7">
                        <div className="p-2 bg-grey mb-2 skeleton"></div>
                        <div className="p-2 bg-grey mb-2 skeleton"></div>
                        <div className="p-2 bg-grey mb-4 skeleton"></div>
                        <div className="p-2 bg-grey mb-2 skeleton"></div>
                      </div>
                  </div>
                  <div className="row mb-4">
                      <div className="col-12">
                        <div className="p-3 bg-grey skeleton"></div>
                      </div>
                  </div>
                  <div className="mb-4">
                      <div className="row mb-3 justify-content-between">
                        <div className="col-4">
                            <div className="p-2 bg-grey skeleton"></div>
                        </div>
                        <div className="col-3">
                            <div className="p-2 bg-grey skeleton"></div>
                        </div>
                      </div>
                      <div className="row mb-3 justify-content-between">
                        <div className="col-4">
                            <div className="p-2 bg-grey skeleton"></div>
                        </div>
                        <div className="col-3 justify-content-between">
                            <div className="p-2 bg-grey skeleton"></div>
                        </div>
                      </div>
                      <div className="row mb-3 justify-content-between">
                        <div className="col-4">
                            <div className="p-2 bg-grey skeleton"></div>
                        </div>
                        <div className="col-3">
                            <div className="p-2 bg-grey skeleton"></div>
                        </div>
                      </div>
                      <div className="row mb-4 justify-content-between">
                        <div className="col-4">
                            <div className="p-2 bg-grey skeleton"></div>
                        </div>
                        <div className="col-3">
                            <div className="p-2 bg-grey skeleton"></div>
                        </div>
                      </div>
                      <div className="row mb-3 justify-content-between">
                        <div className="col-4">
                            <div className="p-3 bg-grey skeleton"></div>
                        </div>
                        <div className="col-3">
                            <div className="p-3 bg-grey skeleton"></div>
                        </div>
                      </div>
                  </div>
                </div>
            </div>
          </div>
      </div>
    </div>
  );
};
return (
  <div className={`nc-CheckOutPage ${className}`} data-nc-id="CheckOutPage">
    <Helmet title="Tiny Away | Checkout"></Helmet>
    {isdataLoaded  ?
          <main className="container mt-11 mb-24 lg:mb-32 flex flex-col-reverse lg:flex-row">
            <div className=" w-full lg:block flex-grow">{renderSidebarCartDetails()}</div>
            {isCartProceed ? 
            <div className=" w-2/3 pl-4 sm-full">{renderPaymentSection()}</div>
            :""}
          </main> 
          :
          <main className="container mt-11 mb-24 ">
            {renderskeletonLoader()}
          </main>
    }
    </div>
);
};
export default CheckOutPage;
